import { render } from "./fold-block.vue?vue&type=template&id=7f422260"
import script from "./fold-block.vue?vue&type=script&lang=js"
export * from "./fold-block.vue?vue&type=script&lang=js"

import "./fold-block.vue?vue&type=style&index=0&id=7f422260&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__